import { __assign } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { Box } from '../Box/index.js';
import { getPanelId, getTabId } from './utils/generateIds.js';
import { useTabsContext } from './contexts/TabsContext.js';
import { useTabPanelsContext } from './contexts/TabsPanelsContext.js';

var TabPanel = function (_a) {
    var children = _a.children;
    var _b = useTabsContext(), id = _b.id, selectedId = _b.selectedId, look = _b.look, divider = _b.divider;
    var panelIndex = useTabPanelsContext().panelIndex;
    var isSelected = selectedId === panelIndex;
    return (jsx(Box, __assign({ themeKey: "tabPanel", role: "tabpanel", id: getPanelId(id, panelIndex), "aria-hidden": !isSelected, "aria-labelledby": getTabId(id, panelIndex), sx: {
            display: isSelected ? undefined : "none",
            paddingY: look === "card" ? 6 : 0,
            paddingX: look === "card" || divider ? 6 : 0,
        } }, { children: children })));
};

export { TabPanel };
//# sourceMappingURL=TabPanel.js.map
